export const removeTrailingSlashes = (path: string) => path.replace(/\/+$/, "");
export const removeLeadingSlashes = (path: string) => path.replace(/^\/+/, "");

export const createUrl = (...sections: string[]) => {
  return sections.reduce((url, section) => {
    const withoutTrailingSlashes = removeTrailingSlashes(url);
    const withoutLeadingSlashed = removeLeadingSlashes(section);
    
    return withoutTrailingSlashes.concat("/", removeTrailingSlashes(withoutLeadingSlashed));
  });
}